import { Typography } from '@mui/material'
import React, { useContext } from 'react'
import styles from "../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss";
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../context/flowBuilderContext';
import { Handle, Position } from '@xyflow/react';
import { WorkflowContext, WorkflowContextPayload } from '../../../../context/workflowContext';
import { isCurrentViewVersionPublished } from '../utilityFunctions';
import globalStyles from "../../../../assets/styles/global.module.scss";
import { getCustomVariableConditionText } from '../flowBuilderConstants';
import { useFlowBuilderStore } from '../../../../store/flowBuilderStore';

const CustomVarConditionNode = ({ id, data }: { id: string, data: any }) => {
    const customVariableList = useFlowBuilderStore((state) => state.customVariableList)
    const { edges } = useContext(FlowBuilderContext) as FlowBuilderContextPayload;
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload;

    return (
        <>
            {data.action_data?.chatbot_custom_variable_configuration_id ?
                <div>
                    <Typography className={styles.dataSavedTextStyle}>{`Condition `}</Typography>
                    {!(edges.find((edge: any) => edge?.sourceHandle?.split("+")[0] == data?.action_data?.unique_id)) &&
                        <span className={styles.dataSavedValueStyle}>
                            Please Link this condition to save.
                        </span>
                    }
                    <Typography className={`${styles.dataSavedValueStyle} ${globalStyles.relativePosition}`} sx={{ padding: "8px 12px", boxShadow: "0 0 2px 0 rgba(0, 0, 0, 0.25)", borderRadius: "8px", marginTop: "10px", maxWidth: "400px !important" }}>
                        <span>
                            {getCustomVariableConditionText(customVariableList, data?.action_data)}
                        </span>
                        <Handle
                            type="source"
                            position={Position.Right}
                            isConnectable={!isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                            id={(data?.action_data?.chatbot_custom_variable_configuration_id && data?.action_data?.operator_type_id && data?.action_data?.unique_id) ? `${data?.action_data?.unique_id}+${data?.action_data?.chatbot_custom_variable_configuration_id}+${data?.action_data?.operator_type_id}` : ""}
                        />
                    </Typography>
                </div>
                :
                <>
                    <div>
                        <span className={styles.dataSavedTextStyle}>{`Condition `}</span>
                        <span className={styles.dataSavedValueStyle}>
                            {"Please Configure Condition*"}
                        </span>
                    </div>
                </>
            }
        </>
    )
}

export default CustomVarConditionNode
